const SURGERY_CONTEXT_ELEMENT = 'surgeryContextElement';
export default SURGERY_CONTEXT_ELEMENT;
